module.exports = __webpack_public_path__ + "img/img3.1c17c5e3.png";